export default __webpack_public_path__ + "static/media/Riddler.243368ff.png";